import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';

const TextDriftAccelerationListItem = (props) => {
    const { acceleration, index, updateTextElement } = props;

    const onAccelerationChange = (value) => updateTextElement(index, { drift: { acceleration: value } });

    return (
        <SliderListItem
            title='Reactivity'
            displayMultiplier={1}
            value={acceleration}
            min={0}
            max={100}
            step={1}
            onValueChange={onAccelerationChange}
            toolTip='How much drift speeds up during loud audio.'
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const { acceleration } = state.createPreview.present.videoSettings.text.textElements[ownProps.index].drift;
    return { acceleration };
};

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextDriftAccelerationListItem);
